<template>
  <res-select :id="elementId" :readonly="readonly" v-model="selectedYear" :items="years" :attach="attachId" :loading="loading"></res-select>
</template>

<script>
  import ResSelect from '@/components/base/ResSelect.vue';
  import propertyService from '@/services/property';

  export default {
    name: 'fiscalYearSelector',
    components: {
      ResSelect
    },
    data() {
      return {
        years: [],
        loading: true,
        yearsFuture: 3,
      }
    },
    props: {
      value: {
        required: true
      },
      propertyId: {
        required: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      elementId: {
        type: String,
        default: "fiscal-year-selector"
      },
      showPastYears: {
        type: Boolean,
        default: true
      },
      withBudget: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      selectedYear: {
        get () {
          return this.value
        },
        set(newValue) {
          this.$emit("input", newValue)
        }
      },
      attachId() {
        return '#' + this.elementId;
      },
      propertyIsSelected() {
        return Boolean(this.propertyId && this.propertyId.length == 36);
      }
    },
    methods: {
      async loadFiscalYearsForProperty() {
        if (!this.propertyIsSelected) {
          return;
        }
        this.loading = true;
        let yearData = await propertyService.getFullyDefinedFiscalYears(this.propertyId, this.withBudget);
        if (yearData && yearData.length > 0) {
          if (this.showPastYears) {
            this.years = yearData;
            if (this.value && this.years.indexOf(this.value === -1)) {
              this.years.push(this.value);
              this.years = this.years.sort()
            }
            this.selectedYear = this.value || this.years[this.years.length - 1];
          }
          else {
            // how to calculate how many years to actually show
            var currentYear = (new Date()).getFullYear();
            let years = [];
            for (var i = 0; i < yearData.length; i++) {
              var year = yearData[i];
              if (year >= currentYear) {
                years.push(year);
              }
            }

            // how to select current year + 1 or closest recent year?
            if (years.length > 1) {
              this.years = years;
              var selectyear = currentYear + 1;
              this.selectedYear = selectyear;
            } else if (years.length == 1) {
              this.years = years;
              this.selectedYear = currentYear;
            } else {
              var lastyearavailable = yearData.pop()
              years.push(lastyearavailable);
              this.years = years;
              this.selectedYear = lastyearavailable;
            }
          }
        } else {
          this.years = [];
          this.selectedYear = null; 
        }
        this.loading = false;
      }
    },
    watch: {
      propertyId: {
        deep: true,
        immediate: true,
        handler() {
          if (this.propertyIsSelected == true) {
            this.loadFiscalYearsForProperty();
          } else {
            this.loading = true;
            this.years = [];
            this.loading = false;
          }
        }
      },
    }
  }
</script>
